export function LoadingIndicator({ label, compact = false, iconOnly = false }: { label: string; compact?: boolean; iconOnly?: boolean }) {
  return <span className={`loading-indicator${compact ? ' compact' : ''}`} role="status">
    <span className="loading-spinner" aria-hidden="true" />
    <span className={iconOnly ? 'sr-only' : undefined}>{label}</span>
  </span>
}
